module.exports = __webpack_public_path__ + "img/PEC5000_aodo_1-1.1a6f11f3.jpg";